module.exports = __webpack_public_path__ + "img/taste-table1.9bf7f382.png";